var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tabs"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"tabs-contato"}},[_c('ContatoList')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"#tabs-contato"}},[_vm._v("Contato")])])])
}]

export { render, staticRenderFns }